import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Fullscreen from "./Fullscreen"
import { useAuth } from '../hooks/Auth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faLockOpen } from '@fortawesome/free-solid-svg-icons'


export default function Login({scopes}) {
  const [username, setUserName] = useState()
  const [password, setPassword] = useState()
  const navigate = useNavigate()
  const location = useLocation()
  const auth = useAuth()

  const { from } = location.state || { from: { pathname: "/" } }

  const login = () => {
    auth.signin(username, password, scopes, () => navigate(from, { replace: true }))
  }

  useEffect(() => {
    if (auth.token && auth.user) {
      navigate(from, { replace: true })
    }
  }, [from, navigate, auth])

  return(
    <Fullscreen>
      <div className="container mt--8 pb-5">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-7">
            <div className="card bg-secondary shadow border-0">
              <div className="card-body px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <p>
                  {auth.error ?
                    <span className="text-danger">Wrong username, email or password.<br/></span> :
                    <span>Login with the username and password provided by the us. </span>
                  }
                  Please <a href="https://www.flashtech.nl/nl/contact" className="text-blue">contact us</a> if you can not login or have any other problems.
                  </p>
                </div>
                <div className="form-group mb-3">
                  <div className="input-group input-group-alternative">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <FontAwesomeIcon icon={faUser} />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Username or email"
                      onChange={e => setUserName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group input-group-alternative">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <FontAwesomeIcon icon={faLockOpen} />
                      </span>
                    </div>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      onChange={e => setPassword(e.target.value)}
                    />
                  </div>
                </div>
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input className="custom-control-input" id="customCheckLogin" type="checkbox" />
                  <label className="custom-control-label">
                    <span className="text-muted">Remember me</span>
                  </label>
                </div>
                <div className="text-center">
                  <button onClick={login} className="btn btn-primary my-4">Sign in</button>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6">
                <a href="https://www.flashtech.nl/nl/over-ons/ihub" className="text-light">
                  <small>Product Info</small>
                </a>
              </div>
              <div className="col-6 text-right">
                <a href="https://www.flashtech.nl/nl/contact" className="text-light">
                  <small>Contact Us</small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fullscreen>
  )
}